export default {
    configuration: true,
    table: {
        height: 300,
        leftOperation: true,
        leftWidth: 150,
        selectBtn: false,
        columns: [
            {
                label: '逾期类型',
                prop: 'overdueTypeName',
                sort: true,
                width: 150
            },
            {
                label: '一级逾期原因',
                prop: 'overdueReasonName',
                sort: true,
                width: 150
            },
            {
                label: '二级逾期原因',
                prop: 'overdueReasDetailName',
                sort: true,
                width: 150
            },
            {
                label: '逾期原因描述',
                prop: 'overdueDesc',
                sort: true,
                width: 150
            },
            {
                label: '发车单号',
                prop: 'dispatchNo',
                sort: true,
                width: 150
            },
            {
                label: '运输单号',
                prop: 'taskNo',
                sort: true,
                width: 150
            },
            {
                label: '创建人',
                prop: 'createUserName',
                sort: true,
                width: 150
            },
            {
                label: '创建时间',
                prop: 'createTime',
                sort: true,
                width: 150
            },
            {
                label: '最后操作人',
                prop: 'updateUserName',
                sort: true,
                width: 150
            },
            {
                label: '最后修改时间',
                prop: 'updateTime',
                sort: true,
                width: 150
            },
            {
                label: '备注',
                prop: 'remark',
                sort: true,
                width: 150
            }
        ],
        action: {
            list: []
        }
    },
    page: {
        layout: 'total, sizes, prev, pager, next',
        pageSize: 10,
        pageSizes: [10, 20, 30, 50]
    }
};
